// extracted by mini-css-extract-plugin
export default {"titleAndButton":"HeaderTitle_titleAndButton__po2fg","title":"HeaderTitle_title__ViM1Q"};